import CommentsNode from './CommentsNode';

export default CommentsNode;
